import { Component } from '@angular/core';
import { ManuallyUploadedConsultNotesComponent } from '../../../captures/components/manually-uploaded-consult-notes/manually-uploaded-consult-notes.component';

@Component({
    selector: 'app-capture-admin-client-consult-notes',
    templateUrl: './capture-admin-client-consult-notes.component.html',
    imports: [ManuallyUploadedConsultNotesComponent]
})
export class CaptureAdminClientConsultNotesComponent {}
